import { GlobalResponseObject, UnitRequest } from '@gtpl/shared-models/common-models';
import axios from 'axios';
import connection from './connection';
import { AllLotCodeOpsResponseModel, AllProdInvResponseModel, AssignLotMaterialReq, LotCodeDropDownResponse, LotCodeOpsResponseModel, LotCreationReq, LotInfoReportReq, MaterialInfoReq, OperationandLotReq, ProdInvResponseModel } from '@gtpl/shared-models/production-management';
import { SaleOrderItemsDropdownResponse, SoNumbersResponseModel } from '@gtpl/shared-models/sale-management';
import {  saleOrder, SaleOrderItemsRequest} from '@gtpl/shared-services/sale-management';
import { CommonResponse } from '@gtpl/shared-models/masters';


export class LotCodeOpsService {
    URL = connection.DEPLOY_URL + '/lot-code-ops';
    
    async createLotCodeOps(values):Promise<LotCodeOpsResponseModel>{
        return await axios.post(this.URL + '/createLotCodeOps',values)
        .then(res => {
            return res.data
        })
    }

    async updateLotCodeOps(values):Promise<LotCodeOpsResponseModel>{
        return await axios.post(this.URL + '/updateLotCodeOps',values)
        .then(res => {
            return res.data
        })
    }


    async getAllLotOps(plantReq?: UnitRequest):Promise<CommonResponse>{
        return await axios.post(this.URL + '/getAllLotOps',plantReq)
        .then(res => {
            return res.data
        })
    }

    async getAllLotNumbers(req?: UnitRequest):Promise<LotCodeDropDownResponse>{
        return await axios.post(this.URL + '/getAllLotNumbers',req)
        .then(res => {
            return res.data
        })
    }

    async getSaleOrders() :Promise<SoNumbersResponseModel>{
        return await axios.post(this.URL + '/getSaleOrders')
        .then(res => {
            return res.data
        })
    }

    async getSaleOrderItemsForSo(req: saleOrder): Promise<SaleOrderItemsDropdownResponse>{
        return await axios.post(this.URL + '/getSaleOrderItemsForSo',req)
        .then(res => {
            return res.data
        })
    }

    async getAllLotNumbersForSoItem(req: SaleOrderItemsRequest): Promise<LotCodeDropDownResponse>{
        return await axios.post(this.URL + '/getAllLotNumbersForSoItem',req)
        .then(res => {
            return res.data
        })
    }
    async getLotCodeTracking(): Promise<CommonResponse>{
        return await axios.post(this.URL + '/getLotCodeTracking')
        .then(res => {
            return res.data
        })
    }
    async getSonumberforQaQcrejection(req:OperationandLotReq): Promise<CommonResponse>{
        return await axios.post(this.URL + '/getSonumberforQaQcrejection',req)
        .then(res => {
            return res.data
        })
    }

    async createLot(req:LotCreationReq): Promise<CommonResponse>{
        return await axios.post(this.URL + '/createLot',req)
        .then(res => {
            return res.data
        })
    }

    async getOpenLotsInfo(): Promise<CommonResponse>{
        return await axios.post(this.URL + '/getOpenLotsInfo')
        .then(res => {
            return res.data
        })
    }

    async getMaterialForLot(req:MaterialInfoReq): Promise<CommonResponse>{
        return await axios.post(this.URL + '/getMaterialForLot',req)
        .then(res => {
            return res.data
        })
    }

    async getWorkOrderDropdown(): Promise<CommonResponse>{
        return await axios.post(this.URL + '/getWorkOrderDropdown')
        .then(res => {
            return res.data
        })
    }

    async getVariantDropdown(): Promise<CommonResponse>{
        return await axios.post(this.URL + '/getVariantDropdown')
        .then(res => {
            return res.data
        })
    }

    async assignMaterialAgainstLot(req:AssignLotMaterialReq[]): Promise<CommonResponse>{
        return await axios.post(this.URL + '/assignMaterialAgainstLot',req)
        .then(res => {
            return res.data
        })
    }

    async getAssignedLotInfo(): Promise<CommonResponse>{
        return await axios.post(this.URL + '/getAssignedLotInfo')
        .then(res => {
            return res.data
        })
    }

    async getLotInfo(req:LotInfoReportReq): Promise<CommonResponse>{
        return await axios.post(this.URL + '/getLotInfo', req)
        .then(res => {
            return res.data
        })
    }

    async getLotNumberForLotInfo(): Promise<CommonResponse>{
        return await axios.post(this.URL + '/getLotNumberForLotInfo')
        .then(res => {
            return res.data
        })
    }

    async getWorkOrderNumberForLotInfo(): Promise<CommonResponse>{
        return await axios.post(this.URL + '/getWorkOrderNumberForLotInfo')
        .then(res => {
            return res.data
        })
    }

    async getLotInfoViewData(req?:any): Promise<CommonResponse>{
        return await axios.post(this.URL + '/getLotInfoViewData', req)
        .then(res => {
            return res.data
        })
    }

    async getExportLotDetailView(req?:any): Promise<CommonResponse>{
        return await axios.post(this.URL + '/getExportLotDetailView', req)
        .then(res => {
            return res.data
        })
    }

        async getFromToLotNumberDropdown(): Promise<CommonResponse>{
        return await axios.post(this.URL + '/getFromToLotNumberDropdown')
        .then(res => {
            return res.data
        })
    }

}